import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsProviderOptionsApi extends ComponentAPI<never> {

  @AwesomeEvent
  onOptionClick = new ClickEventListener();

}

export default HpmsProviderOptionsApi;
